import React from "react";
import { useNavigate } from "react-router-dom";
import "./CategoriesSection.css";

const categories = [
  {
    label: "Land",
    icon: (
      <svg
        width="70"
        height="70"
        viewBox="0 0 24 24"
        fill="none"
        stroke="black"
        strokeWidth="1.5"
      >
        <path d="M3 17l9-6 9 6-9 6-9-6z" />
        <path d="M12 11V3" />
        <path d="M9 6h6" />
      </svg>
    ),
  },
  {
    label: "Warehouse",
    icon: (
      <svg
        width="70"
        height="70"
        viewBox="0 0 24 24"
        fill="none"
        stroke="black"
        strokeWidth="1.5"
      >
        <path d="M3 10l9-7 9 7v10a1 1 0 0 1-1 1h-5v-6H9v6H4a1 1 0 0 1-1-1V10z" />
      </svg>
    ),
  },
  {
    label: "Commercial",
    icon: (
      <svg
        width="70"
        height="70"
        viewBox="0 0 24 24"
        fill="none"
        stroke="black"
        strokeWidth="1.5"
      >
        <rect x="3" y="3" width="7" height="18" />
        <rect x="14" y="8" width="7" height="13" />
        <path d="M6.5 3v18" />
      </svg>
    ),
  },
  {
    label: "Industrial",
    icon: (
      <svg
        width="70"
        height="70"
        viewBox="0 0 24 24"
        fill="none"
        stroke="black"
        strokeWidth="1.5"
      >
        <path d="M3 21V10l5 3V10l5 3V10l8 5v6H3z" />
        <path d="M17 6c0 1.5 2 1.5 2 3s-2 1.5-2 3" />
      </svg>
    ),
  },
];

const locations = [
  { name: "Baner", properties: 200 },
  { name: "Hinjewadi", properties: 100 },
  { name: "Hadapsar", properties: 422 },
  { name: "Katraj", properties: 200 },
  { name: "Aundh", properties: 200 },
  { name: "Viman Nagar", properties: 200 },
];

const CategoriesSection = () => {
  const navigate = useNavigate();

  const handleCategoryClick = (category) => {
    navigate(`/properties?propertyType=${category}`);
  };

  return (
    <section className="categories-wrapper">
      <h2 className="sub-heading">ATLAS SPACES CATEGORIES</h2>
      <h3 className="main-heading">Explore Our Categories & Places</h3>

      <div className="category-grid">
        {categories.map((cat) => (
          <div
            key={cat.label}
            className="category-card"
            onClick={() => handleCategoryClick(cat.label)}
            style={{ cursor: "pointer" }}
          >
            <div className="category-icon">{cat.icon}</div>
            <div className="category-label">{cat.label}</div>
          </div>
        ))}
      </div>

      <div className="locations-grid">
        {locations.map((loc) => (
          <div key={loc.name} className="location-item">
            <p className="location-name">{loc.name}</p>
            <p className="location-properties">{loc.properties} Properties</p>
          </div>
        ))}
      </div>
    </section>
  );
};

export default CategoriesSection;
